import React, {useEffect, useRef, useState} from 'react'
import "../stylesheets/BrandHub.css";
import {getCampaigns} from "../services/CampaignService";
import Content from "./Content";
import {getBusinessContent, getBusinessCreators} from "../services/BusinessService";
import {Image, StyleSheet, Text, View, Pressable} from 'react-native-web';
import blueLandscapeIcon from '../icons/blue-landscape-icon.png';
import Header from "./Header";
import {useSearchParams} from "react-router-dom";



const ContentHub = () => {

    const [content, setContent] = useState([])
    const [additionalContent, setAdditionalContent] = useState([])
    const [campaigns, setCampaigns] = useState([])
    const [creators, setCreators] = useState([])
    const selectedCampaignId = useRef();
    const selectedUserId = useRef();
    const [page, setPage] = useState(2)
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(()=>{
        getBusinessContent(null, searchParams.get("campaign"), searchParams.get("user"))
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    setContent(resp.data);
                    selectedCampaignId.current = searchParams.get("campaign");
                    selectedUserId.current = searchParams.get("user");
                }
            })
        getCampaigns()
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    setCampaigns(resp.data);
                }
            })
        getBusinessCreators()
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    setCreators(resp.data);
                }
            })
    }, [searchParams]);

    function getCampaignContent(campaignId) {
        // If the same campaign is already selected, clear the filter
        if (selectedCampaignId.current === campaignId) {
            getBusinessContent(null, null, null)
                .then(resp => {
                    if (resp.status === 200 && resp.data) {
                        setContent(resp.data);
                        selectedCampaignId.current = null;
                        selectedUserId.current = null;
                        setPage(2);
                        searchParams.delete("campaign");
                        searchParams.delete("user");
                        setSearchParams(searchParams);
                    }
                })
        } else {
            // Apply the campaign filter
            getBusinessContent(null, campaignId, null)
                .then(resp => {
                    if (resp.status === 200 && resp.data) {
                        setContent(resp.data);
                        selectedCampaignId.current = campaignId;
                        selectedUserId.current = null;
                        setPage(2);
                        searchParams.delete("campaign");
                        searchParams.delete("user");
                        searchParams.append("campaign", campaignId);
                        setSearchParams(searchParams);
                    }
                })
        }
    }

    function getUsersCampaignContent(userId) {
        // If the same user is already selected, clear the filter
        if (selectedUserId.current === userId) {
            getBusinessContent(null, null, null)
                .then(resp => {
                    if (resp.status === 200 && resp.data) {
                        setContent(resp.data);
                        selectedCampaignId.current = null;
                        selectedUserId.current = null;
                        setPage(2);
                        searchParams.delete("campaign");
                        searchParams.delete("user");
                        setSearchParams(searchParams);
                    }
                })
        } else {
            // Apply the user filter
            getBusinessContent(null, null, userId)
                .then(resp => {
                    if (resp.status === 200 && resp.data) {
                        setContent(resp.data);
                        selectedCampaignId.current = null;
                        selectedUserId.current = userId;
                        setPage(2);
                        searchParams.delete("campaign");
                        searchParams.delete("user");
                        searchParams.append("user", userId);
                        setSearchParams(searchParams);
                    }
                })
        }
    }

    function retrieveNextContent() {
        getBusinessContent(page, selectedCampaignId.current, selectedUserId.current)
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    setAdditionalContent(resp.data);
                    setPage(page+1);
                }
            })
    }

    function clearAllFilters() {
        getBusinessContent(null, null, null)
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    setContent(resp.data);
                    selectedCampaignId.current = null;
                    selectedUserId.current = null;
                    setPage(2);
                    searchParams.delete("campaign");
                    searchParams.delete("user");
                    setSearchParams(searchParams);
                }
            })
    }

    return(
        <div>
            <Header title={"Content"}/>
            <div style={styles.contentDiv}>
                <Content retrieveNextContent={retrieveNextContent} content={content} additionalContent={additionalContent}/>
            </div>
            <View style={styles.settingsDiv}>
                <View style={styles.filtersContainer}>
                    <View style={styles.settingsHeaderDiv}>
                        <Text style={styles.h3}>Filters</Text>
                        {(selectedCampaignId.current || selectedUserId.current) && (
                            <Pressable 
                                style={({ hovered }) => [
                                    styles.clearFiltersButton,
                                    hovered && styles.clearFiltersButtonHovered
                                ]}
                                onPress={clearAllFilters}
                                accessible={true}
                                accessibilityLabel="Clear all filters"
                                accessibilityRole="button"
                            >
                                <Text style={styles.clearFiltersText}>Clear Filters</Text>
                            </Pressable>
                        )}
                    </View>
                    
                    <View style={styles.filterSection}>
                        <Text style={styles.h5}>Campaigns</Text>
                        <View style={styles.filterItemsContainer}>
                            {campaigns && campaigns.length > 0 && campaigns.map(campaign => (
                                <Pressable 
                                    key={campaign.id}
                                    style={({ hovered }) => [
                                        styles.filterItem,
                                        (selectedCampaignId.current === campaign.id) ? styles.selectedFilterItem : {},
                                        hovered && styles.filterItemHovered
                                    ]}
                                    onPress={() => {getCampaignContent(campaign.id)}}
                                    accessible={true}
                                    accessibilityLabel={selectedCampaignId.current === campaign.id ? `Remove ${campaign.name} campaign filter` : `Filter by ${campaign.name} campaign`}
                                    accessibilityRole="button"
                                >
                                    <Image 
                                        style={styles.campaignFilterImage} 
                                        source={campaign.imageExists 
                                            ? {uri: 'https://d3p3fw3rutb1if.cloudfront.net/business/photos/' + campaign.id}
                                            : blueLandscapeIcon
                                        } 
                                    />
                                    <View style={styles.filterItemInfo}>
                                        <Text style={styles.filterItemTitle} numberOfLines={2}>
                                            {campaign.name}
                                        </Text>
                                    </View>   
                                </Pressable>
                            ))}
                        </View>
                    </View>

                    <View style={styles.filterSection}>
                        <Text style={styles.h5}>Creators</Text>
                        <View style={styles.filterItemsContainer}>
                            {creators && creators.length > 0 && creators.map(creator => (
                                <Pressable 
                                    key={creator.id}
                                    style={({ hovered }) => [
                                        styles.filterItem,
                                        (selectedUserId.current === creator.id) ? styles.selectedFilterItem : {},
                                        hovered && styles.filterItemHovered
                                    ]}
                                    onPress={() => {getUsersCampaignContent(creator.id)}}
                                    accessible={true}
                                    accessibilityLabel={selectedUserId.current === creator.id ? `Remove ${creator.first_name} ${creator.last_name} filter` : `Filter by ${creator.first_name} ${creator.last_name}`}
                                    accessibilityRole="button"
                                >
                                    <Image 
                                        style={styles.creatorFilterImage} 
                                        source={{uri: "https://d3p3fw3rutb1if.cloudfront.net/users/" + creator.id}} 
                                    />
                                    <View style={styles.filterItemInfo}>
                                        <Text style={styles.filterItemTitle} numberOfLines={1}>
                                            {creator.first_name} {creator.last_name}
                                        </Text>
                                        <Text style={styles.filterItemSubtitle} numberOfLines={1}>
                                            {creator.posts} uploads
                                        </Text>
                                    </View>
                                </Pressable>
                            ))}
                        </View>
                    </View>
                </View>
            </View>
        </div>
    );
}

const styles = StyleSheet.create({
    settingsDiv: {
        display: 'inline-block',
        width: '25%',
        height: 'calc(100vh - 50px)',
        verticalAlign: 'top',
        overflow: 'scroll',
        backgroundColor: '#f8f9ff',
        padding: 16,
    },
    contentDiv: {
        display: 'inline-block',
        width: '75%',
        height: 'calc(100vh - 50px)',
        overflow: 'scroll',
        verticalAlign: 'top',
    },
    filtersContainer: {
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 20,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 8,
        elevation: 3,
        borderWidth: 1,
        borderColor: '#e5e7eb',
    },
    settingsHeaderDiv: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 20,
        paddingBottom: 15,
        borderBottomWidth: 1,
        borderBottomColor: '#e5e7eb',
    },
    filterSection: {
        marginBottom: 24,
    },
    filterItemsContainer: {
        gap: 8,
    },
    filterItem: {
        backgroundColor: 'white',
        borderRadius: 8,
        padding: 12,
        borderWidth: 1,
        borderColor: '#e5e7eb',
        flexDirection: 'row',
        alignItems: 'center',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        outlineStyle: 'none',
    },
    filterItemHovered: {
        backgroundColor: '#f9fafb',
        borderColor: '#396de0',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
        elevation: 2,
        transform: [{ scale: 1.02 }],
    },
    selectedFilterItem: {
        backgroundColor: '#f3f4f6',
        borderColor: '#396de0',
        borderWidth: 2,
        shadowColor: '#396de0',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.15,
        shadowRadius: 6,
        elevation: 4,
    },
    campaignFilterImage: {
        width: 48,
        height: 48,
        borderRadius: 8,
        marginRight: 12,
        backgroundColor: '#f3f4f6',
        borderWidth: 1,
        borderColor: '#e5e7eb',
    },
    creatorFilterImage: {
        width: 48,
        height: 48,
        borderRadius: 24,
        marginRight: 12,
        backgroundColor: '#f3f4f6',
        borderWidth: 1,
        borderColor: '#e5e7eb',
    },
    filterItemInfo: {
        flex: 1,
        justifyContent: 'center',
    },
    filterItemTitle: {
        fontFamily: "'lato', sans-serif",
        fontSize: 14,
        fontWeight: '600',
        color: '#374151',
        lineHeight: 18,
        marginBottom: 2,
    },
    filterItemSubtitle: {
        fontFamily: "'lato', sans-serif",
        fontSize: 12,
        color: '#6b7280',
        lineHeight: 16,
    },
    h3: {
        color: '#396de0',
        fontFamily: "'forma-djr-display', sans-serif",
        fontSize: 20,
        fontWeight: 'bold',
    },
    clearFiltersButton: {
        backgroundColor: '#f3f4f6',
        borderRadius: 6,
        paddingHorizontal: 12,
        paddingVertical: 6,
        borderWidth: 1,
        borderColor: '#e5e7eb',
        transition: 'all 0.2s ease',
        outlineStyle: 'none',
    },
    clearFiltersButtonHovered: {
        backgroundColor: '#e5e7eb',
        borderColor: '#396de0',
        transform: [{ scale: 1.05 }],
    },
    clearFiltersText: {
        fontFamily: "'lato', sans-serif",
        fontSize: 12,
        fontWeight: '600',
        color: '#6b7280',
    },
    h5: {
        color: '#396de0',
        fontFamily: "'forma-djr-display', sans-serif",
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 12,
    },

    // Legacy styles - keeping for compatibility but should be removed eventually
    campaignImg: {
        width: '50px',
        height: '50px',
        display: 'inline-block',
        objectFit: 'cover',
        borderRadius: '5px',
    },
    campaignPreviewDiv: {
        cursor: 'pointer',
        paddingLeft: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start', 
        marginBottom: '10px',
        paddingTop: '5px', 
        paddingBottom: '5px',
        flexDirection: 'row',
    },
    selectedFilterDiv: {
        backgroundColor : '#b8cbf5',
    },
    campaignInfoDiv: {
        flex: '1',
        whiteSpace: 'normal',
        marginLeft: '10px',
        marginRight: '10px',
    },
    inline: {
        display: 'inline-block',
        wordWrap: 'break-word',
        lineHeight: '1.2em'
    },
    justifyCenter: {
        justifyContent: 'center'
    },
    creatorInfoP: {
        marginBottom: 0,
    },
    creatorInfoDiv: {
        display: 'inline-block',
        verticalAlign: 'top',
        marginLeft: '10px',
    },
});

export default ContentHub
